export default __webpack_public_path__ + "static/Conditions generales de vente Francais-6e2f6a187dd662bf2c312f154c6c2922.pdf";